import { render } from "./AwardsFullSlider.vue?vue&type=template&id=90a2a22e&scoped=true&ts=true"
import script from "./AwardsFullSlider.vue?vue&type=script&lang=ts"
export * from "./AwardsFullSlider.vue?vue&type=script&lang=ts"

import "./AwardsFullSlider.vue?vue&type=style&index=0&id=90a2a22e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90a2a22e"]])

export default __exports__